export default __webpack_public_path__ + "static/Event2-063e82ffca63f3c72cf5845a29bbb592.jpg";